import {
  FaCalendarAlt,
  FaLink,
  FaBell,
  FaClock,
  FaChartBar,
  FaStar,
  FaShieldAlt,
  FaMobileAlt,
  FaRocket,
  FaHeadset,
} from "react-icons/fa";

// ─── Data ─────────────────────────────────────────────────────────────────────
export const reasons = [
  "Az ügyfelek nem mindig tudják, mikor érnek el téged – így elmarad a kapcsolatfelvétel.",
  "Te sem vagy mindig elérhető – így elvesznek a potenciális ügyfelek.",
  "Az üzenetváltások sok időt visznek el – ráadásul könnyen elfelejtődnek.",
  "Az emberek azonnali megoldást keresnek – nem várakozást.",
  "Az adminisztráció terhet jelent – amit egy rendszer automatizálhatna.",
  "A folyamatos telefonhívások megzavarják a munkát.",
  "A hagyományos időpontfoglalás könnyen félreértésekhez vezet.",
  "Weboldal nélkül nem tudsz megfelelő online jelenlétet biztosítani.",
];

export const items = [
  "Sokan keresnek fel, de nehéz egyeztetni velük.",
  "Gyakran kell visszahívni vagy utánamenni az időpontnak.",
  "Szeretnél kevesebb időt tölteni adminisztrációval.",
  "Fontos neked a profi, modern megjelenés.",
  "Egyszerűsítenéd a kommunikációt az ügyfelekkel.",
  "Szeretnéd, ha a foglalások maguktól történnének.",
  "Jó lenne azonnal értesíteni ügyfeleidet egy felszabadult időpontról.",
  "Unod a Canvában szerkeszteni a szabad időpontjaidat.",
  "Szeretnéd az áraidat és szolgáltatásaidat egy helyen bemutatni.",
  "Jó lenne egy weboldal és időpontfoglaló, de túl drága és bonyolult.",
  "Blogolnál, de a honlapfejlesztés még drágább lenne.",
  "Egyéni vagy csoportos foglalkozásokat tartasz, speciális eszközök beállításával.",
];

export const excuse = [
  "Szeretsz munka közben csengő telefonokra ugrálni – az a kis izgalom kell a napodba.",
  "Imádod, ha egy ügyfél hatszor újraírja ugyanazt az időpontot Messengeren.",
  "Szeretsz visszahívni mindenkit.",
  "Szereted, ha munka után is csipog az üzenet: Holnapra lenne valami?",
  "Jobban szereted a cetliket és noteszeket, mint egy digitális rendszert.",
  "Mindegy, hogy a szabad időpontra találsz-e ügyfelet.",
  "A káosz a komfortzónád – rendet csak másoknál szeretsz látni.",
  "Nem zavar, ha nincs tele a naptárad.",
];

export const features = [
  {
    icon: FaShieldAlt,
    title: "Nincs kockázat",
    body: "30 napos ingyenes próbaidőszak, nem kérünk kártyaadatokat.",
  },
  {
    icon: FaCalendarAlt,
    title: "Személyre szabható",
    body: "Időpontfoglaló rendszer, beágyazható módban is, pontosan a te igényeidre szabva.",
  },
  {
    icon: FaStar,
    title: "Egyéni & csoportos",
    body: "Egyéni és csoportos szolgáltatások, kérdőívvel a pontosabb ügyfél-megértésért.",
  },
  {
    icon: FaClock,
    title: "Várólista",
    body: "Hogy egyetlen időpontod se maradjon kihasználatlanul.",
  },
  {
    icon: FaLink,
    title: "Többoldalas weboldal",
    body: "Szolgáltatásbemutatóval és bloggal, extra fejlesztési költség nélkül.",
  },
  {
    icon: FaHeadset,
    title: "Beállítási segítség",
    body: "Technikai support és ingyenes konzultáció – biztosan jó helyen jársz.",
  },
];

export const solutionCards = [
  {
    icon: FaRocket,
    title: "Gyors indulás",
    body: "Akár 1 órán belül használatra kész foglalórendszer.",
  },
  {
    icon: FaCalendarAlt,
    title: "Nem kell fejlesztő",
    body: "Egyszerű kezelőfelület, amit Te is tudsz használni.",
  },
  {
    icon: FaMobileAlt,
    title: "Mobilbarát",
    body: "Bárhonnan, bármilyen eszközről elérhető.",
  },
  {
    icon: FaBell,
    title: "Nincs elfelejtett időpont",
    body: "Minden foglalás automatikusan értesítést küld.",
  },
  {
    icon: FaHeadset,
    title: "Konzultáció & támogatás",
    body: "Segítünk minden lépésnél.",
  },
  {
    icon: FaChartBar,
    title: "Költséghatékony",
    body: "Egyszerű, mégis hatékony megoldás fejlesztői díjak nélkül.",
  },
];
